import { axiosInstance } from '@/utils/api'
import { IManufacturingPlan } from '@/utils/types/model/manufacturingPlan'
import { ISearchConditionBlock } from '@/utils/types'

interface IMOListResponse {
  totalRecords: number
  manufacturingPlans: IManufacturingPlan[]
}

export interface IExportBulkReportRequest {
  condition: {
    projectCode: string
    version: number
    utcOffset?: number
    searchConditionBlocks: ISearchConditionBlock[]
    logicalOperator?: string
    isToday?: boolean
    sortKey: string
    sortOrder: number
  }
  reportTemplateCode: string
}

export async function getAllMO(
  page: number,
  limit: number,
  filter?: string,
  sort?: string,
  orderNumber?: string,
  sortBy?: string,
  sortType?: string
): Promise<IMOListResponse> {
  const params: Record<string, unknown> = {
    page,
    limit,
  }

  if (filter) {
    params.filter = filter
  }

  if (sort) {
    params.sort = sort
  }
  if (orderNumber) {
    params.orderNumber = orderNumber
  }

  if (sortBy) {
    params.sortBy = sortBy
  }

  if (sortType) {
    params.sortType = sortType
  }

  const response = await axiosInstance.get('/manufacturingPlans', { params })
  return response.data
}

export async function getOneMO(id: string): Promise<IManufacturingPlan> {
  const response = await axiosInstance.get(`/manufacturingPlan/${id}`)
  return response.data
}

export async function exportManufacturingOrder(data: { sortBy?: string; sortType?: string }) {
  const response = await axiosInstance.post('/manufacturingPlans/export', data)
  return response.data
}

export async function exportBulkReportOutput(data: IExportBulkReportRequest) {
  return axiosInstance.post('/manufacturingPlans/export-reports', data)
}
